import { useCallback } from "react"

const KEYS = {
  volume: "cosmo_player_volume",
  muted: "cosmo_player_muted",
  rate: "cosmo_player_rate",
}

export function usePlayerPreferences(playerRef) {
  const onPlayerReady = useCallback(() => {
    // Force HLS.js to start loading segments — guards against Strict Mode
    // double-mount race conditions where startLoad() is never called
    const hlsPlayer = playerRef.current?.getInternalPlayer("hls")
    if (hlsPlayer && typeof hlsPlayer.startLoad === "function") {
      hlsPlayer.startLoad(-1)
    }

    const videoEl = playerRef.current?.getInternalPlayer()
    if (!videoEl || typeof videoEl.volume === "undefined") return

    const savedVolume = localStorage.getItem(KEYS.volume)
    const savedRate = localStorage.getItem(KEYS.rate)

    if (savedVolume !== null) videoEl.volume = parseFloat(savedVolume)
    if (savedRate !== null) videoEl.playbackRate = parseFloat(savedRate)

    const handleVolumeChange = () => {
      localStorage.setItem(KEYS.volume, videoEl.volume)
    }
    const handleRateChange = () => {
      localStorage.setItem(KEYS.rate, videoEl.playbackRate)
    }

    videoEl.addEventListener("volumechange", handleVolumeChange)
    videoEl.addEventListener("ratechange", handleRateChange)
  }, [playerRef])

  return { onPlayerReady }
}
